const DOMAIN = 'lending.services.public.onboarding.lzOnboarding.processEndedContainer.';

const PROCESS_ENDED_DESCRIPTION = `${DOMAIN}emptyStatusComponent.description`,
  PROCESS_ENDED_TITLE = `${DOMAIN}emptyStatusComponent.title`;

export { PROCESS_ENDED_DESCRIPTION, PROCESS_ENDED_TITLE };
